import ReactDOM from 'react-dom/client';
import './index.css';
import 'the-last-spelling-bee-re-captcha/dist/the-last-spelling-bee-re-captcha.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ColorModeScript } from "@chakra-ui/react"
import { GoogleOAuthProvider } from '@react-oauth/google';
import { PersistGate } from 'redux-persist/integration/react';
import store, { persistor } from './redux/store';
import { Provider } from 'react-redux';


const root = ReactDOM.createRoot(
  document.getElementById('root') as HTMLElement
);
root.render(
  <GoogleOAuthProvider clientId={`109479677317-8rqpgmcber9bqg69775vksakepf1mbg1.apps.googleusercontent.com`}>
  <Provider store={store}>
  <PersistGate loading={null} persistor={persistor}>
    <ColorModeScript />
    <App />
    </PersistGate>
</Provider>
</GoogleOAuthProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
